module.exports = __webpack_public_path__ + "38dc9289ec8f47a0e5db2311ef592be5.pdf";